module.exports = __webpack_public_path__ + "media/src/images/icons/indicator-right-abc6187e7cb83e7ee2a38d8605afb869.svg";